import React from "react" ;
import { Switch, Route } from "react-router-dom";

import SubNavbar from "../Components/SubNavbar";
import Diary from "../Pages/Diary";
import FamilyAndFriends from "../Pages/FamilyAndFriends";

import Messages from "../Pages/Messages";
import LifeStoryAndGallery from "../Pages/LifeStoryAndGallery";
import Resources from "../Pages/Resources";
import ChildPosts from "../Pages/ChildPosts";

const Main = () => {
    return (
        <>
            <SubNavbar />
            <Switch>                
                <Route path="/child/lifestoryandgallery" component={LifeStoryAndGallery} />
                <Route path="/child/resources" component={Resources} />
                <Route path="/child/family" component={FamilyAndFriends} />
                <Route path="/child/child-diary" component={Diary} />
                <Route path="/child/messages" component={Messages} />
                {phpVars.has_lifestory && <Route path={"/child/"} component={ChildPosts} />}
                {!phpVars.has_lifestory && <Route path={"/child/"} component={Messages} />}
            </Switch>
        </>
    );
}

export default Main;
